import { NgModule } from "@angular/core";
import { AgGridModule } from "ag-grid-angular";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { SortimentListComponent } from "./sortiment-list/sortiment-list.component";
import { SortimentRedigeraDialogComponent } from "./sortiment-redigera-dialog/sortiment-redigera-dialog.component";
import { SortimentComponent } from "./sortiment.component";
import { SortimentService } from "./sortiment.service";
@NgModule({
    imports: [
        RaskCommonModule,
        AgGridModule,
        SortimentComponent,
        SortimentRedigeraDialogComponent,
        SortimentListComponent
    ],
    providers: [SortimentService]
})
export class SortimentModule { }
